export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const ACCOUNT = '/account';
export const SUBSCRIBE = '/subscribe';
export const CANCEL = '/cancel';
export const PASSWORD_FORGET = '/pw-forget';